<div
  fxLayout="row"
  fxLayoutAlign="center center"
  class="check-container"
  [ngClass]="{ 'check-container--selected': isChecked }"
>
  <div class="check-icon" [ngClass]="{ 'check-icon--checked': isChecked }"></div>
</div>
